'use client';

import { useState } from 'react';

export default function TestScrapePage() {
  const [url, setUrl] = useState('https://noticias.uol.com.br/cotidiano/ultimas-noticias/2025/03/06/onibus-acidente-dutra-sp.htm');
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleTest = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetch('/api/test-scrape', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ url })
      });

      const data = await response.json();
      setResult(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Teste de Scraping</h1>
      
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          className="flex-1 p-2 border rounded"
          placeholder="Digite a URL"
        />
        <button
          onClick={handleTest}
          disabled={loading}
          className="px-4 py-2 bg-blue-500 text-white rounded disabled:bg-blue-300"
        >
          {loading ? 'Testando...' : 'Testar'}
        </button>
      </div>

      {error && (
        <div className="p-4 mb-4 bg-red-100 text-red-700 rounded">
          {error}
        </div>
      )}

      {result && (
        <div className="space-y-4">
          <div className="p-4 bg-gray-100 rounded">
            <h2 className="font-bold">Metadados:</h2>
            <pre className="whitespace-pre-wrap">
              {JSON.stringify(result.metadata, null, 2)}
            </pre>
          </div>

          <div>
            <h2 className="font-bold mb-2">
              Imagens encontradas: {result.total}
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {result.images.map((img: any, i: number) => (
                <div key={i} className="border rounded p-2">
                  <img
                    src={img.url}
                    alt={img.alt || 'Imagem'}
                    className="w-full h-48 object-cover mb-2"
                  />
                  <div className="text-sm">
                    <div className="truncate">{img.url}</div>
                    {img.alt && <div className="text-gray-600">{img.alt}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 